import Commons from '../shared/libraries/commons';
import { Countries } from '../shared/libraries/countries';
import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class ServiceSerializer extends BaseSerializer {
  deserialize(raw) {
    const serverRes = raw.data || raw.error;
    const success = serverRes.statusCode == 200;
    // if (!success) {
    //   return {
    //     statusCode: serverRes.statusCode || raw.status || 500,
    //     success: false,
    //     message:
    //       (serverRes.message || 'Erreur lors de la récupération') +
    //       ` Code d'erreur: INIT_ERR_${
    //         serverRes.statusCode || raw.status || '1000'
    //       }`,
    //     data: null
    //   };
    // }
    return {
      statuCode: 200,
      success: true,
      message: 'Initiated',
      data: null
    };
  }

  serialize(raw, fees, userData, appConfigs) {
    console.log('🚀 ~ ServiceSerializer ~ serialize ~ raw:', raw);
    const userPhonePrefix = Countries.find(userData.countryCode)?.phonePrefix;
    raw.fullPhoneNumber = `${userPhonePrefix}${raw.phoneNumber}`;
    const trxId = Commons.generateUUID();
    const requestId = Commons.generateUUID();
    const transaction = {
      id: trxId,
      requestId: requestId,
      src: formatSrc(raw, fees, userData, trxId, requestId, appConfigs),
      dst: formatDst(raw, fees, userData, trxId, requestId, appConfigs),
      service: '1xpay',
      metadata: {
        userId: userData.id,
        email: userData.email,
        country: userData.countryCode,
        firstName: userData.firstName,
        lastName: userData.lastName,
        amounts: fees,
        trxService: raw.service.id,
        trxServiceOperation: raw.operation.id,
        otp: raw.otpCode,
        ...(raw.isWave ? { isWave: true } : {}),
        feeData: {
          ...this.serializeFee(raw, userData, false),
          amount: 0
        }
      }
    };
    let provider = raw.mobileMoneyOperationConfigs.provider;
    if (transaction.src.phoneNumber) {
      transaction.src.provider = provider;
    }
    if (transaction.dst.phoneNumber) {
      transaction.dst.provider = provider;
    }
    return transaction;
  }

  serializeFee(raw, userData, isSrcChange) {
    const key = `${raw.operation?.id}:${raw.service?.id}`;
    const operationKeys = {
      'fund:1xbet': 'fund1xBet',
      'withdraw:1xbet': 'withdrawal1xBet',
      'fund:betwinner': 'fundBetWinner',
      'withdraw:betwinner': 'withdrawalBetWinner',
      'fund:1win': 'fund1Win',
      'withdraw:1win': 'withdrawal1Win',
      'fund:melbet': 'fundMelbet',
      'withdraw:melbet': 'withdrawalMelbet',
      'fund:eightStarz': 'fundEightStarz',
      'withdraw:eightStarz': 'withdrawalEightStarz',
      'buy:usdt': 'buyUsdt',
      'sell:usdt': 'sellUsdt'
    };
    return {
      service: '1xpay',
      userId: '1xpay',
      computeAmountToPay: !isSrcChange,
      amount: isSrcChange ? raw.senderAmount : raw.recipientAmount,
      country: userData.countryCode,
      processor: 'any',
      operation: operationKeys[key],
      phoneNumber: raw.phoneNumber
      // phoneOperator: raw.isWave ? 'WAVE' : raw.phoneOperator
    };
  }

  deserializeFee(raw) {
    const success = raw?.statusCode == 200;
    const parsed = {
      statusCode: raw?.statusCode || 500,
      success,
      message:
        raw?.message ||
        (success ? 'Ok' : 'Erreur de calcul des frais. Veuillez réessayer'),
      data: {
        srcAmount: raw?.data?.amountToCollect,
        dstAmount: raw?.data?.amountToDeposit,
        srcServiceFee: raw?.data?.srcServiceFee,
        dstServiceFee: raw?.data?.dstServiceFee,
        srcProcessorFee: raw?.data?.srcProcessorFee,
        dstProcessorFee: raw?.data?.dstProcessorFee,
        earning: raw?.data?.earning,
        bonus: 0,
        fee: raw?.data?.amountToCollect - raw?.data?.amountToDeposit
      }
    };
    return parsed;
  }

  /**
   * Désérialise la réponse du détail d'une transaction.
   * Format réel : { data: { id, status, metadata: { paymentLink } }, statusCode: 200 }
   * Le paymentLink est dans data.metadata.paymentLink
   */
  deserializeTransactionDetail(raw) {
    const data = raw?.data?.data || null;
    return {
      id: data?.id || null,
      paymentLink: data?.metadata?.paymentLink || null,
      status: data?.status || null
    };
  }
}

function formatSrc(raw, fees, userData, trxId, requestId, appConfigs) {
  console.log('🚀 ~ formatSrc ~ raw:', raw);
  if (raw.operation?.id == 'withdraw') {
    return formatBookmakerOperation(
      raw,
      fees,
      userData,
      true,
      trxId,
      requestId
    );
  }
  if (raw.operation?.id == 'sell') {
    // return formatManualOperation(raw, fees, userData, true, trxId, requestId);
  }
  // if (
  //   raw.mobileMoneyOperationConfigs?.isManual &&
  //   raw.mobileMoneyOperationConfigs?.manualOperationInstructions
  // ) {
  //   return formatManualOperation(raw, fees, userData, true, trxId, requestId);
  // }
  if (raw.operation?.id == 'fund' || raw.operation?.id == 'buy') {
    const src = formatMomoOps(raw, fees, userData, true, trxId, requestId);
    if (
      raw.mobileMoneyOperationConfigs?.isManual &&
      raw.mobileMoneyOperationConfigs?.manualOperationInstructions
    ) {
      src.isManual = true;
      src.manualOperationData = raw.manualInfoFilled.manualCollectInfos;
    }
    return src;
  }
  return null;
}

function formatDst(raw, fees, userData, trxId, requestId, appConfigs) {
  if (raw.operation?.id == 'fund') {
    return formatBookmakerOperation(
      raw,
      fees,
      userData,
      false,
      trxId,
      requestId
    );
  }
  if (raw.operation?.id == 'buy') {
    // return formatManualOperation(raw, fees, userData, false, trxId, requestId);
  }
  // if (
  //   raw.mobileMoneyOperationConfigs?.isManual &&
  //   !raw.mobileMoneyOperationConfigs?.manualOperationInstructions
  // ) {
  //   return formatManualOperation(raw, fees, userData, false, trxId, requestId);
  // }
  if (raw.operation?.id == 'sell' || raw.operation?.id == 'withdraw') {
    const dst = formatMomoOps(raw, fees, userData, false, trxId, requestId);
    if (
      raw.mobileMoneyOperationConfigs?.isManual &&
      !raw.mobileMoneyOperationConfigs?.manualOperationInstructions
    ) {
      dst.isManual = true;
    }
    return dst;
  }
  return null;
}

function formatBookmakerOperation(
  raw,
  fees,
  userData,
  isSrc,
  trxId,
  requestId
) {
  const country = userData.countryCode;
  const amount = isSrc ? fees.srcAmount : fees.dstAmount;

  const bookmaker = `${raw.service?.id}`;
  const externalBookmakers = {
    '1xbet': '1xbet',
    betwinner: 'betwinner',
    '1win': '1win',
    melbet: 'melbet',
    eightStarz: '888starz'
  };

  return {
    type: isSrc ? 'withdrawal' : 'funding',
    id: trxId,
    requestId: requestId,
    service: '1xpay',
    currency: /ga/i.test(country) ? 'XAF' : 'XOF',
    amount,
    ...(isSrc
      ? {
          bookmaker: externalBookmakers[bookmaker],
          playerId: raw.bookmakerIdToUse,
          withdrawalCode: raw.withdrawalCode
        }
      : {
          bookmaker: externalBookmakers[bookmaker],
          operationId: trxId,
          playerId: raw.bookmakerIdToUse
        })
  };
}

function formatManualOperation(raw, fees, userData, isSrc, trxId, requestId) {
  const amount = isSrc ? fees.srcAmount : fees.dstAmount;
  const service = raw.service.id;
  const operation = raw.operation.id;

  const bookmakers = ['1xbet', 'betwinner', '1win', 'melbet', 'eightStarz'];
  const isBookmaker = bookmakers.includes(service);

  const externalBookmakers = {
    '1xbet': '1xbet',
    betwinner: 'betwinner',
    '1win': '1win',
    melbet: 'melbet',
    eightStarz: '888starz'
  };

  const type = isSrc ? 'withdrawal' : 'funding';

  const baseData = {
    type,
    id: trxId,
    requestId: requestId,
    service: '1xpay',
    currency: /ga/i.test(userData.countryCode) ? 'XAF' : 'XOF',
    amount
  };

  if (isBookmaker) {
    return {
      ...baseData,
      bookmaker: externalBookmakers[service],
      ...(isSrc
        ? {
            playerId: raw.bookmakerIdToUse,
            withdrawalCode: raw.withdrawalCode,
            lastName: userData.lastName,
            firstName: userData.firstName,
            phoneNumber: raw.fullPhoneNumber
          }
        : {
            operationId: trxId,
            playerId: raw.bookmakerIdToUse,
            phoneNumber: raw.fullPhoneNumber
          })
    };
  }

  if (service === 'usdt') {
    return {
      ...baseData,
      ...(isSrc
        ? {
            lastName: userData.lastName,
            firstName: userData.firstName,
            phoneNumber: raw.fullPhoneNumber,
            usdtAddressType: raw.usdtAddressType.id,
            usdtAccountId: raw.usdtAccountId,
            usdtAmount:
              operation === 'sell'
                ? raw.senderAmountOriginalCurrency
                : raw.recipientAmountOriginalCurrency
          }
        : {
            operationId: trxId,
            usdtAddressType: raw.usdtAddressType.id,
            usdtAccountId: raw.usdtAccountId,
            usdtAmount:
              operation === 'sell'
                ? raw.senderAmountOriginalCurrency
                : raw.recipientAmountOriginalCurrency
          })
    };
  }

  // Mobile money manual operation
  return {
    ...baseData,
    ...(isSrc
      ? {
          lastName: userData.lastName,
          firstName: userData.firstName,
          phoneNumber: raw.fullPhoneNumber,
          phoneOperator: raw.phoneOperator
        }
      : {
          operationId: trxId,
          lastName: userData.lastName,
          firstName: userData.firstName,
          phoneNumber: raw.fullPhoneNumber
        })
  };
}

function formatMomoOps(raw, fees, userData, isSrc, trxId, requestId) {
  const amount = isSrc ? fees.srcAmount : fees.dstAmount;

  return {
    type: isSrc ? 'funding' : 'withdrawal',
    id: trxId,
    requestId: requestId,
    service: '1xpay',
    currency: /ga/i.test(userData.countryCode) ? 'XAF' : 'XOF',
    amount,
    phoneNumber: raw.fullPhoneNumber,
    lastName: userData.lastName,
    firstName: userData.firstName
  };
}

export const serializer = new ServiceSerializer();
